import * as Types from '@praceprofirmy/shared-domain';

import { gql } from 'apollo-angular';
export type CalendarEventFragment = { __typename?: 'CalendarEvent', id: string, name: string, description?: string | null, startTime: string, endTime: string, status: Types.CallendarEventStatus, priority: Types.CallendarEventPriority, type: Types.CalendarEventType, color?: string | null, createdAt: string, editedAt?: string | null, createdBy: string, editedBy?: string | null, organizationId: string, participants: Array<{ __typename?: 'CalendarEventParticipant', id: string, participantId: string }> };

export type CalendarEventParticipantFragment = { __typename?: 'CalendarEventParticipant', id: string, participantId: string, calendarEvent: { __typename?: 'CalendarEvent', id: string, name: string, description?: string | null, startTime: string, endTime: string, status: Types.CallendarEventStatus, priority: Types.CallendarEventPriority, type: Types.CalendarEventType, color?: string | null, createdAt: string, editedAt?: string | null, createdBy: string, editedBy?: string | null, organizationId: string, participants: Array<{ __typename?: 'CalendarEventParticipant', id: string, participantId: string }> } };

export const CalendarEventFragmentDoc = gql`
    fragment CalendarEventFragment on CalendarEvent {
  id
  name
  description
  startTime
  endTime
  status
  priority
  type
  color
  createdAt
  editedAt
  createdBy
  editedBy
  organizationId
  participants {
    id
    participantId
  }
}
    `;
export const CalendarEventParticipantFragmentDoc = gql`
    fragment CalendarEventParticipantFragment on CalendarEventParticipant {
  id
  participantId
  calendarEvent {
    ...CalendarEventFragment
  }
}
    ${CalendarEventFragmentDoc}`;